<template>
  <div :class="'md-layout-item md-small-size-100'">
    <md-card>
      <md-card-content>
        <Form
          @setFormValidation="setFormValidation" />
      </md-card-content>
      <md-card-actions md-alignment="left">
        <md-button :class="'md-default'" @click="$router.push({name: 'Review Reference'})">
          Back
        </md-button>
        <md-button :class="'md-danger'"
          @click.prevent="submit"
          :disabled="!isFormValid || isSubmitting">
          {{ !isSubmitting ? 'Create' : 'Creating ARR...' }}
        </md-button>
      </md-card-actions>
    </md-card>
  </div>
</template>

<script>
  import Form from './Form.vue'

  export default {
    components: {
      Form,
    },

    data () {
      return {
        isSubmitting: false,

        review: {},
        isFormValid: null,

        errorResponses: {
          422: 'There is an error with the Advisory',
        },
      }
    },

    methods: {
      setFormValidation(validForm, review) {
        this.isFormValid = validForm
        this.review = review
      },

      submit () {
        if(this.isFormValid) {
          this.isSubmitting = true

          const arrToBeSent = Object.assign({}, this.review)

          arrToBeSent.start_date = new Date(arrToBeSent.start_date).toISOString().substring(0, 10)
          arrToBeSent.end_date = new Date(arrToBeSent.end_date).toISOString().substring(0, 10)
          arrToBeSent.deadline_docs = new Date(arrToBeSent.deadline_docs).toISOString().substring(0, 10)

          this.$api.request.post('advisories', arrToBeSent)
            .then(() => {
              this.$toast.show('ARR successfully created', '')
              this.$router.push({ name: 'Review Reference' })
            })
            .catch(error => {
              if (error.response.data.message) {
                this.$toast.show(error.response.data.message)
              } else if (this.errorResponses[error.response.status]) {
                this.$toast.show(this.errorResponses[error.response.status])
              } else {
                this.$toast.show('Ops, something went wrong! Please, try again.')
              }
            })
            .finally(() => {
              this.isSubmitting = false
            })
        }
      }
    },
  }
</script>
